import { render } from "./IndexPage.vue?vue&type=template&id=979a5ea6&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=979a5ea6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-979a5ea6"

export default script